module.exports = {"632622100":"赛来塘镇","632622200":"多贡麻乡","632622201":"马可河乡","632622202":"吉卡乡","632622203":"达卡乡","632622204":"知钦乡","632622205":"江日堂乡","632622206":"亚尔堂乡","632622207":"灯塔乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632622.json
// module id = 3006
// module chunks = 0